import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { IsLoginChecker } from '../../common/checkers/IsLoginChecker';
import { TrackPageViewContainer } from '../../common/containers/TrackPageViewContainer';
import { t } from '../../common/getTranslations';
import { Loading } from '../../design-system/atoms/Loading/Loading';
import { Layout } from '../../design-system/layout/Layout';
import { RedeemContainer } from '../../domain/redeem/container/RedeemContainer';
import { Redeem } from '../../domain/redeem/presentational/Redeem';
import { CommonMobileHeaderType } from '../../header/constants';
function RedeemPage() {
  const router = useRouter();
  if (!router.isReady) {
    return <div className="flex-center-full">
        <Loading />
      </div>;
  }
  return <>
      <IsLoginChecker>
        <RedeemContainer>{props => <Redeem {...props} />}</RedeemContainer>
      </IsLoginChecker>

      <TrackPageViewContainer trackObj={{
      section: '더보기',
      page: '쿠폰등록',
      actionType: 'Pageview',
      actionName: '쿠폰등록_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </>;
}
RedeemPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('more_coupon_register')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.ThreeDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default RedeemPage;